import React, {useContext, useMemo} from "react";
import * as Yup from "yup";
import ValidateMessages from "../../../../../../../../../core/models/static/texts/vallidate-messages";
import {makeRequired, makeValidate} from "mui-rff";
import {UserHomepageControllerContext} from "../../../../../../index";
import Form from "../../../../../../../../components/base/form";
import classnames from "classnames";
import {Col} from "reactstrap";
import {OutlinedInputForm} from "../../../../../../../../components/base/input/outlined_input";
import SaveOrRollback from "../../../../../../../../components/app-specific/save-or-rollback";
import {preventEventPropagation} from "../../../../../../../../../core/services/utils/utils";
import useIsMounted from "../../../../../../../../hooks/use-is-mounted";


const schema = Yup.object().shape({
    title: Yup.string().trim().nullable().required(ValidateMessages.required)
});

const validate = makeValidate(schema);
const required = makeRequired(schema);


const UserHomepageControlPanelTabCardTitleSection = ({
                                                         tabId,
                                                         currentName,
                                                         inEditMode,
                                                         exitEditMode,
                                                         disabled,
                                                         update,
                                                     }) => {
    const controller = useContext(UserHomepageControllerContext);
    const showSaveOrRollback = useMemo(() => inEditMode, [inEditMode]);
    const initialValues = useMemo(() => ({
        title: currentName,
    }), [currentName])
    const isMounted = useIsMounted();


    /**
     * Updates the title of the current tab in the server by calling the update callback.
     *
     * * if the result of the update callback is successful, commits the changes and exists the edit mode.
     * * @param values
     */
    const submitForm = async (values) => {
        if (values.title === initialValues.title) {
            return exitEditMode();
        }
        const resultFlag = await update(values.title);
        if (!isMounted())
            return;
        if (resultFlag) {
            updateTabTitle(values.title, true);
        }
    }

    /**
     * Changes the tab's title without committing it.
     * @param {InputEvent} e
     * @param {formApi} form
     */
    const liveChangeTabTitle = (e, form) => {
        const newTitle = e.target.value ?? '';
        form.change(e.target.name, newTitle);
        updateTabTitle(newTitle, false);
    }

    /**
     * Reverts the title changes back to its initial values.
     * @param {string} newTitle
     * @param {formApi} form
     */
    const revertTitleChanges = (newTitle, form) => {
        form.resetFieldState('title');
        if (initialValues.title === newTitle)
            return exitEditMode();
        form.change('title', initialValues.title);
        form.resetFieldState('title');
        updateTabTitle(initialValues.title, true);
    }

    /**
     * Updates the tab title in the controller.
     *
     * * if committed, then exits the edit mode.
     * @param {string} title
     * @param {boolean} commit
     */
    const updateTabTitle = (title, commit = false) => {
        controller.updateTab({
            id: tabId,
            name: title,
        }, commit)
        if (commit) {
            exitEditMode();
        }
    }

    return (
        <>
            <Form
                className={classnames('user-homepage-input-container', {inEditMode})}
                onSubmit={submitForm}
                validate={validate}
                initialValues={initialValues}
                render={({values, form}) => {
                    return (
                        <>
                            <Col className={'flex-fill'}>
                                <OutlinedInputForm
                                    fullWidth
                                    disabled={!inEditMode}
                                    name={'title'}
                                    placeholder={inEditMode ? 'title...' : ''}
                                    className={'mr-2'}
                                    required={required.title}
                                    value={values.title ?? ''}
                                    onChange={(e) => liveChangeTabTitle(e, form)}
                                />
                            </Col>
                            <Col xs={'auto'}
                                 className={'d-flex align-items-center'}
                                 onClick={preventEventPropagation}
                            >
                                <SaveOrRollback
                                    show={showSaveOrRollback}
                                    loading={disabled}
                                    column={false}
                                    onRollback={() => revertTitleChanges(values.title, form)}
                                    onSave={form.submit}
                                />
                            </Col>
                        </>
                    )
                }}
            />
        </>
    );

}
export default UserHomepageControlPanelTabCardTitleSection;
